/* eslint-disable react/prop-types */
import React from "react";
import { Col, Layout } from "antd";
import H2 from "../../components/typography/section-heading";

const LAYOUT_SKELETON = {
  margin: "0px -48px",
  background: "var(--vc-bg)",
  paddingBottom: "48px",
};

/** Matches `LandingSection`: layout `paddingTop` (40) + Col top padding (24) below border/divider */
const SECTION_TITLE_TOP_SPACING = "64px";

/** Full-bleed horizontal rule aligned with landing gutters */
export function SectionRule() {
  return (
    <div
      role="separator"
      aria-hidden
      style={{
        borderTop: "1px solid var(--vc-border)",
        margin: "48px -48px 0",
      }}
    />
  );
}

const MARQUEE_EDGE_GRADIENT =
  "linear-gradient(to right, #0B0908, #0B0908 15%, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), rgba(255, 255, 255, 0), #0B0908 85%, #0B0908)";

/** Full-width marquee strip with edge fade overlay */
export function MarqueeBand({ children }) {
  return (
    <div
      style={{
        padding: "20px 0",
        margin: "0px -48px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundImage: MARQUEE_EDGE_GRADIENT,
          zIndex: 1,
          pointerEvents: "none",
        }}
      />
      {children}
    </div>
  );
}

const COL_PROPS = {
  className: "gutter-row",
  xs: { span: 24 },
  lg: { span: 16, offset: 4 },
};

/**
 * Standard landing block: top border, reading column, optional H2.
 */
export function LandingSection({
  title,
  divided = true,
  className,
  colStyle,
  children,
}) {
  return (
    <Layout
      className={className}
      style={{
        ...LAYOUT_SKELETON,
        borderTop: divided ? "1px solid var(--vc-border)" : undefined,
        paddingTop: divided ? "40px" : 0,
      }}
    >
      <Col
        {...COL_PROPS}
        style={{
          marginTop: 0,
          padding: "24px",
          ...colStyle,
        }}
      >
        {title != null && (
          <>
            <H2 color="var(--vc-text)">{title}</H2>
            <br />
          </>
        )}
        {children}
      </Col>
    </Layout>
  );
}

/**
 * H2 + edge-fade marquee row. Use `leadingDivider` when a prior ticker exists.
 */
export function LandingTickerSection({ title, leadingDivider, children }) {
  return (
    <>
      {leadingDivider ? <SectionRule /> : null}
      <div
        style={{
          paddingTop: leadingDivider ? SECTION_TITLE_TOP_SPACING : 0,
        }}
      >
        <H2 color="var(--vc-text)">{title}</H2>
        <MarqueeBand>{children}</MarqueeBand>
      </div>
    </>
  );
}

/**
 * Reading-width title; body (e.g. marquees) stays full band width below.
 */
export function LandingWideSection({ title, leadingDivider, children }) {
  return (
    <>
      {leadingDivider ? <SectionRule /> : null}
      <Layout
        style={{
          margin: "0px -48px",
          background: "var(--vc-bg)",
          paddingTop: leadingDivider ? SECTION_TITLE_TOP_SPACING : "24px",
          paddingBottom: "24px",
        }}
      >
        <Col {...COL_PROPS} style={{ padding: "0 24px 16px" }}>
          <H2 color="var(--vc-text)">{title}</H2>
          <br />
        </Col>
        {children}
      </Layout>
    </>
  );
}
